import React from 'react';
import classnames from 'classnames';
import pluralize from 'pluralize';

import { getPlaceholderIcon } from '../../helpers/file';

import type { Asset } from '../../types/asset';

interface MemoryCardAssetsProps {
  variant: 'memory' | 'timeline' | 'sprk';
  files: Asset[];
};

const MemoryCardAssets: React.FC<MemoryCardAssetsProps> = ({ files, variant }) => {
  let displayedFiles = files.slice(0, variant === 'timeline' ? 7 : 3);
  let more = files.length - displayedFiles.length;
  if (more === 1) {
    more = 0;
    displayedFiles = files.slice(0, displayedFiles.length + 1);
  }

  return (
    <div className="memory-card-assets wa-cluster wa-gap-2xs">
      {displayedFiles.map((file) => (
        <div key={file.id} className={classnames('memory-card-asset', { 'memory-card-asset-placeholder': !file.thumbnail })}>
          {file.thumbnail ? (
            <img src={file.thumbnail} alt={file.name} className="memory-card-asset-thumbnail" />
          ) : (
            <i className={`fa-light fa-3x ${getPlaceholderIcon(file.type)}`} />
          )}
        </div>
      ))}
      {variant === 'memory' && (
        more > 0 ? (
          <div className="memory-card-asset memory-card-asset-more">
            <span>+{more} {pluralize('file', more)}</span>
          </div>
        ) : (
          <>
            {Array(4 - displayedFiles.length).fill(null).map((_, index) => (
              <div key={index} className="memory-card-asset memory-card-asset-empty"></div>
            ))}
          </>
        )
      )}
      {variant === 'timeline' && (
        more > 0 && (
          <div className="memory-card-asset memory-card-asset-more">
            <span>+{more} {pluralize('file', more)}</span>
          </div>
        )
      )}
      {variant === 'sprk' && (
        files.length === 0 && (
          <div className="memory-card-asset memory-card-asset-empty"></div>
        )
      )}
    </div>
  );
}

export default MemoryCardAssets;
